// extracted by mini-css-extract-plugin
export default {"msgM":"f9c1858cf9"};